import { render, staticRenderFns } from "./addTextDialog.vue?vue&type=template&id=49ee5464&scoped=true"
import script from "./addTextDialog.vue?vue&type=script&lang=js"
export * from "./addTextDialog.vue?vue&type=script&lang=js"
import style0 from "./addTextDialog.vue?vue&type=style&index=0&id=49ee5464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ee5464",
  null
  
)

export default component.exports